import { Backdrop, CircularProgress } from "@mui/material";
import {
  LOADING_OVERLAY_BACKGROUND,
  LOADING_OVERLAY_SPINNER_SIZE_PX,
} from "@/constants/loading-overlay-constant";

interface LoadingOverlayProps {
  isLoading: boolean;
}

/** Full-screen loading state: a light translucent layer with the brand spinner, shown while an API call runs. */
const LoadingOverlay = ({ isLoading }: LoadingOverlayProps) => (
  <Backdrop
    sx={(theme) => ({
      zIndex: theme.zIndex.modal + 1,
      bgcolor: LOADING_OVERLAY_BACKGROUND,
      color: theme.palette.primary.main,
    })}
    open={isLoading}
  >
    <CircularProgress color="inherit" size={LOADING_OVERLAY_SPINNER_SIZE_PX} />
  </Backdrop>
);

export default LoadingOverlay;
